import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import './styles/dashboard-override.css'
import { useAuth } from './hooks/useAuth'
import LoginForm from './components/LoginForm'
import SidebarLayout from './layouts/SidebarLayout'

// Lazy load pages for better performance
const Dashboard = React.lazy(() => import('./pages/Dashboard'))
const Users = React.lazy(() => import('./pages/Users'))
const UserManagement = React.lazy(() => import('./pages/UserManagement'))
const Subscriptions = React.lazy(() => import('./pages/Subscriptions'))
const Videos = React.lazy(() => import('./pages/Videos'))
const CloudflareContentManager = React.lazy(() => import('./pages/CloudflareContentManager'))
const VideoReports = React.lazy(() => import('./pages/VideoReports'))
const Entitlements = React.lazy(() => import('./pages/Entitlements'))
const PromoCodes = React.lazy(() => import('./pages/PromoCodes'))
const Affiliates = React.lazy(() => import('./pages/Affiliates'))
const FeatureFlags = React.lazy(() => import('./pages/FeatureFlags'))
const UserCohorts = React.lazy(() => import('./pages/UserCohorts'))
const MarketingManager = React.lazy(() => import('./pages/MarketingManager'))
const Pricing = React.lazy(() => import('./pages/Pricing'))
const Activity = React.lazy(() => import('./pages/Activity'))
const Settings = React.lazy(() => import('./pages/Settings'))
const ForceMessages = React.lazy(() => import('./pages/ForceMessages'))
const DownloadManager = React.lazy(() => import('./pages/DownloadManager'))
const SupportTickets = React.lazy(() => import('./pages/SupportTickets'))
const Analytics = React.lazy(() => import('./pages/Analytics'))
const DownloadsAnalytics = React.lazy(() => import('./pages/DownloadsAnalytics'))
const UserImpersonation = React.lazy(() => import('./pages/UserImpersonation'))

export default function App() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p className="mt-2 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginForm />;
  }

  return (
    <div className="admin-dashboard">
    <React.Suspense fallback={
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p className="mt-2 text-muted-foreground">Loading...</p>
        </div>
      </div>
    }>
      <Routes>
        <Route element={<SidebarLayout />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/subscriptions" element={<Subscriptions />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/categories" element={<CloudflareContentManager />} />
          <Route path="/categories-admin" element={<CloudflareContentManager />} />
          <Route path="/content-manager" element={<CloudflareContentManager />} />
          <Route path="/reports" element={<VideoReports />} />
          <Route path="/entitlements" element={<Entitlements />} />
          <Route path="/promo-codes" element={<PromoCodes />} />
          <Route path="/affiliates" element={<Affiliates />} />
          <Route path="/feature-flags" element={<FeatureFlags />} />
          <Route path="/user-cohorts" element={<UserCohorts />} />
          <Route path="/marketing" element={<MarketingManager />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/force-messages" element={<ForceMessages />} />
          <Route path="/download-manager" element={<DownloadManager />} />
          <Route path="/support-tickets" element={<SupportTickets />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/downloads-analytics" element={<DownloadsAnalytics />} />
          <Route path="/impersonation" element={<UserImpersonation />} />
        </Route>
      </Routes>
    </React.Suspense>
    </div>
  )
}
